<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="card-title mb-0">
          <span class="lstick"></span>Charity Transactions List
        </h4>
      </div>

      <div class="table-responsive" *ngIf="!loading">
        <table class="table table-striped border mt-4">
          <thead>
            <tr>
              <th scope="col">Order Number</th>
              <th scope="col">Invoice Number</th>
              <th scope="col">Charity Name</th>
              <th scope="col">Charity Description</th>
              <th scope="col">Charity Percentage</th>
              <th scope="col">Charity Amount</th>
              <th scope="col">Date</th>
              <th scope="col">Actions</th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let val of donation">
              <td>{{ val.orderNumber }}</td>
              <td>{{ val.invoice_number }}</td>
              <td>{{ val.donationId?.charityName?val.donationId?.charityName:"-" }}</td>
              <td>
                <p placement="top" [ngbTooltip]="val.donationId?.charityDescription">
                  {{
                  val.donationId?.charityDescription?.length > 30
                  ? (val.donationId?.charityDescription | slice : 0 : 20) + "..."
                  : val.donationId?.charityDescription
                  }}
                </p>
              </td>
              <td>{{ val.donationPercentage }} %</td>
              <td class=" font-bold">
                {{ currency }}
                {{ val.amount| number : "1.2-2" }}
              </td>

              <td>{{ val.created_at | date : "medium" }}</td>
              <td>
                <div class="d-flex flex-row">
                  <!-- View Details Icon Button -->
                  <button class="btn btn-sm btn-primary m-1" (click)="viewDonationDetails(val)" placement="top"
                    ngbTooltip="View details">
                    <i class="fa fa-eye"></i>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="donation?.length == 0 && !loading">
              <td colspan="9" class="text-center">No Charity found</td>
            </tr>
          </tbody>
        </table>

        <!-- Pagination -->
        <div class="d-flex justify-content-center mt-5" *ngIf="donation?.length != 0">
          <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="totalCount" [maxSize]="7"
            [rotate]="true" [ellipses]="false" [boundaryLinks]="true" (pageChange)="loadPage($event)">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>